import { Observable } from "../../utilities/index.js";
export function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/utils/fromError.js
// module id = 530
// module chunks = 0